/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2017
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../lib/@waca/dashboard-common/dist/core/Model',
	'./sources/SourcesCollection',
	'underscore'
], function (Model, SourcesCollection, _) {
	'use strict';

	var SourcesModelVersion = '1.0';

	var DataSourceModel = Model.extend({
		nestedCollections: {
			sources: SourcesCollection
		},

		whitelistAttrs: ['version', 'sources'],

		init: function (model) {
			if (model) {
				_.defaults(model, {
					sources: [],
					version: SourcesModelVersion
				});
			}

			DataSourceModel.inherited('init', this, arguments);
		}
	});

	return DataSourceModel;
});
